/**
 * @module "behavior/register.view.behavior"
 * @description This needs a description
 * @property {object} defaults - name
 */

define('formkit/behavior/register.view.behavior',['require','exports','module','underscore','marionette','backbone.radio'],function(require, exports, module) {
  //prettier-ignore
  var _ = require('underscore'),
      Mn = require('marionette'),
      Radio = require('backbone.radio');

  /**
   * @class RegisterViewBehavior
   */
  var RegisterViewBehavior = Mn.Behavior.extend({
    defaults: {
      name: null,
    },

    /**
     * @method initialize
     * @constructs
     * @augments external:Mn.Behavior
     */

    initialize: function() {
      Mn.Behavior.prototype.initialize.apply(this, arguments);

      if (this.getOption('name')) {
        Radio.reply('viewInstances', this.getOption('name'), _.constant(this.view));
        Radio.trigger('viewInstances', 'reply:' + this.getOption('name'), this.view);
      }
    },

    /**
     * @method onDestroy
     */

    onDestroy: function() {
      var channelView = Radio.request('viewInstances', this.getOption('name'));
      if (channelView == this.view) {
        Radio.stopReplying('viewInstances', this.getOption('name'));
      }
    },
  });

  module.exports = RegisterViewBehavior;
});

